
import Anchors from '@scripts/utilities/anchors.js';


(function(window, jQuery) {
  jQuery(window).on('load', function() {
    jQuery(document).on('click', 'a', function(event) {
      var target = event.target;
      var anchor = target.closest('a');

      if (anchor) {
        if (Anchors.isExternal(anchor)) {
          var properties = {};

          if (window.articleAnalytics) {
            properties = window.articleAnalytics;
          }

          var clickProperties = Object.assign({}, properties);
          clickProperties.destination_url = anchor.href;

          CSAnalyticsClick(
            'Outbound Link Clicked',
            clickProperties,
            anchor,
            event
          );
        }
      }
    });
  });
})(window, jQuery);

